import React, { useEffect } from "react";
import { Radio, RadioGroup } from "@headlessui/react";
import { motion } from "framer-motion";
import { useFormikContext } from "formik";
import clsx from "clsx";
import ReactCountryFlag from "react-country-flag";
import { usePageSettings } from "../../../contexts/PageSettingsContext"


const CheckoutProfileSelector = ({ profileList, selectedProfile, setSelectedProfile }) => {
	const { setFieldValue } = useFormikContext();
	const { translations } = usePageSettings();

	const handleProfileChange = (profile) => {
		setFieldValue("configuration.paymentProfile", profile);
		setSelectedProfile(profile);
	};

	useEffect(() => {
		setFieldValue("configuration.paymentProfile", selectedProfile);
	}, [selectedProfile]);

	return (
		<div className="flex flex-col gap-4">
			<h2 className="flex flex-col text-zinc-200 gap-2 text-base font-bold">{translations["CheckoutProfileSelectorTitle"]}</h2>
			<RadioGroup value={selectedProfile} onChange={handleProfileChange}>
				<motion.div
					variants={{
						initial: { opacity: 1 },
						animate: {
							opacity: 1,
							transition: { staggerChildren: 0.1 },
						},
					}}
					initial="initial"
					animate="animate"
					className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4"
				>
					{profileList?.map((profile) => (
						<motion.div
							key={profile.id}
							variants={{ initial: { opacity: 0, y: 20 }, animate: { opacity: 1, y: 0 } }}
						>
							<Radio
								value={profile}
								disabled={!profile.authorized}
								className={({ checked, disabled }) =>
									clsx(
										"group transition-all duration-500 min-h-[72px] px-5 py-2.5 w-full border border-zinc-800 flex items-center justify-between rounded-lg",
										{
											"bg-zinc-800 cursor-pointer": checked && !disabled,
											"bg-zinc-950 opacity-50 cursor-not-allowed": disabled,
											"bg-zinc-950 hover:bg-zinc-900 cursor-pointer": !checked && !disabled,
										}
									)
								}
							>
								{({ checked, disabled }) => (
									<div className="flex w-full justify-between items-center">
										<div className="flex flex-col">
											<span className="flex gap-2 items-center py-2.5">
												<div
													className={clsx(
														"w-3 h-3 rounded-full transition-all duration-500",
														{
															"bg-ipxon-magenta": checked && !disabled,
															"bg-zinc-600": !checked || disabled,
														}
													)}
												/>
												{profile.name} {profile.lastname}
											</span>
											<span className="text-zinc-500 text-sm font-normal">
												UID {profile.id} {disabled ? " - Disabled by admin" : null}
											</span>
										</div>
										<div
											className={clsx("transition-all duration-500", {
												"opacity-100": checked && !disabled,
												"opacity-50": !checked || disabled,
											})}
										>
											<ReactCountryFlag
												style={{
													fontSize: "1.75em",
													lineHeight: "1.75rem",
												}}
												countryCode={profile.country || "US"}
												svg
											/>
										</div>
									</div>
								)}
							</Radio>
						</motion.div>
					))}
				</motion.div>
			</RadioGroup>
		</div>
	);
};

export default CheckoutProfileSelector;
